import useCheckoutState from '../hooks/useCheckoutState';
import getSafeReadableColor from '../lib/getSafeReadableColor';
import darken from '../utils/darken';
import React from 'react';

export default function CheckoutCSS() {
  const { page, seller, isTesting, isPreview, isTestingPayments } = useCheckoutState();

  const shouldShowCustomCSS = (() => {
    // measuring in dashboard
    if (!isPreview && isTesting && isTestingPayments) return false;

    // testing payments in dashboard
    if (isTestingPayments) return true;

    // preview in dashboard
    if (!isPreview) return true;

    // livemode
    if (!isTesting) return true;

    return false;
  })();

  return (
    <>
      {shouldShowCustomCSS && <style>{page.customCss}</style>}

      <style
        dangerouslySetInnerHTML={{
          __html: `
      html {
        --color-primary: ${seller.brandColor};
        --color-primary-dark: ${darken(seller.brandColor, 0.1)};
        --color-secondary: ${getSafeReadableColor(seller.brandColor)};
        --variant-background-color: ${page.variantBackgroundColor || '#fff'};
        --variant-selected-background-color: ${page.variantSelectedBackgroundColor || '#fff'};
        --variant-selected-border-color: ${page.variantSelectedBorderColor || seller.brandColor};
        --ticket-type-background-color: ${page.ticketTypeBackgroundColor || '#fff'};
        --ticket-type-selected-background-color: ${
          page.ticketTypeSelectedBackgroundColor || '#fff'
        };
        --ticket-type-selected-border-color: ${
          page.ticketTypeSelectedBorderColor || seller.brandColor
        };
        --payment-option-background-color: ${page.paymentOptionBackgroundColor || '#fff'};
        --payment-option-selected-background-color: ${
          page.paymentOptionSelectedBackgroundColor || '#fff'
        };
        --payment-option-selected-border-color: ${
          page.paymentOptionSelectedBorderColor || seller.brandColor
        };
    `,
        }}
      />
    </>
  );
}
